export class DeleteAreeINModel { 
    idAree: number
}